(() => {
  const setup = root => {
    if (root.dataset.enhanced) return;
    const tabs = [...root.querySelectorAll('[data-home-tab]')];
    const panels = [...root.querySelectorAll('[data-home-panel]')];
    if (tabs.length !== panels.length || !tabs.length) return;
    const activate = (index, focus = false) => {
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(next, true); }
      });
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
    });
    root.dataset.enhanced = 'true';
    root.querySelector('[role="tablist"]').hidden = false;
    activate(0);
  };
  const init = () => document.querySelectorAll('[data-editorial-home]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
